var REACT_ELEMENT_TYPE;function _jsx(e, r, E, l) {REACT_ELEMENT_TYPE || (REACT_ELEMENT_TYPE = "function" == typeof Symbol && Symbol.for && Symbol.for("react.element") || 60103);var o = e && e.defaultProps,n = arguments.length - 3;if (r || 0 === n || (r = { children: void 0 }), 1 === n) r.children = l;else if (n > 1) {for (var t = Array(n), f = 0; f < n; f++) t[f] = arguments[f + 3];r.children = t;}if (r && o) for (var i in o) void 0 === r[i] && (r[i] = o[i]);else r || (r = o || {});return { $$typeof: REACT_ELEMENT_TYPE, type: e, key: void 0 === E ? null : "" + E, ref: null, props: r, _owner: null };}import { Field } from 'react-redux-form';
import Immutable from 'immutable';
import PropTypes from 'prop-types';
import React, { Component } from 'react';
import { Translate } from "../../I18N";
import { NestedMultiselect } from "../../ReactReduxForms";

class NestedFilter extends Component {
  render() {
    const { onChange, model, label, property, aggregations } = this.props;
    return /*#__PURE__*/(
      _jsx("ul", { className: "search__filter is-active" }, void 0, /*#__PURE__*/
      _jsx("li", {}, void 0, /*#__PURE__*/
      _jsx("label", {}, void 0, label), /*#__PURE__*/
      _jsx("div", { className: "nested-strict" }, void 0, /*#__PURE__*/
      _jsx(Field, { model: `${model}.strict` }, void 0, /*#__PURE__*/
      _jsx("input", { id: `${model}strict`, type: "checkbox", onChange: onChange })
      ), /*#__PURE__*/
      _jsx("label", { htmlFor: `${model}strict` }, void 0, /*#__PURE__*/
      _jsx("span", {}, void 0, "\xA0", /*#__PURE__*/
      _jsx(Translate, {}, void 0, "Strict mode")
      )
      )
      )
      ), /*#__PURE__*/
      _jsx("li", { className: "wide" }, void 0, /*#__PURE__*/
      _jsx(NestedMultiselect, { aggregations: aggregations, property: property, onChange: onChange })
      )
      ));

  }
}

NestedFilter.defaultProps = {
  onChange: () => {},
  label: '',
  aggregations: Immutable.Map()
};









export default NestedFilter;